import { SitngoCodePanel } from '@/components/hub/panels/SitngoCodePanel';
import { BACKGAMMON_PROFILE_TYPE } from '@/lib/qgammon/lobbyTornei';

/**
 * «Sit&Go» del BACKGAMMON — i sit&go di qTournaments (kind `sit-and-go`, ADR-0163) con «Entra/Esci» come per Clash
 * Royale (Luca, I-334 punto 4, 04/10: «Anche nei tornei di backgammon voglio sezione sit & go e coda sit come fatto
 * per clash royale»; I-340: solo il Sit&Go, niente coda 1v1 Limulo per il BG).
 *
 * Lo STESSO pannello di CR, non una copia: `SitngoCodePanel` col `profileType` del backgammon. Il biglietto,
 * il rinnovo, la ripresa, «Partita trovata» e i rifiuti sono quelli delle code (`CodeTorneiContext`,
 * `useCodeTorneiPannello`), scopati sul gioco. «Partita trovata» porta alla scheda dell'INCONTRO, dove «Entra al
 * tavolo» (`tavoloDaAprireOf`) apre la partita su QGammon: nessun deep link nuovo.
 *
 * Esiste solo con `sitngoBackgammonAcceso()` (`lobbySections.ts`: la scheda non si offre a flag spento). Senza un
 * modello di coda attivo per il backgammon il pannello dice, onesto, «Nessun sit&go aperto per Backgammon».
 */
export function SitngoBackgammonPanel() {
  return <SitngoCodePanel profileType={BACKGAMMON_PROFILE_TYPE} />;
}
